var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VTextField',_vm._g(_vm._b({ref:"input",class:_vm.styles,attrs:{"value":_vm.value,"hide-details":_vm.hideDetails},on:{"input":function($event){return _vm.$emit('input', $event)}}},'VTextField',_vm.attrs,false),_vm.listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }